/* PAGINA 9 · MINORI — accesso, account & exchange, dati storici, impostazioni.
 *
 * Le quattro schermate minori del prototipo riunite sotto un'unica rotta, con
 * la sezione nell'URL: /impostazioni/account è un indirizzo che si può mandare
 * a qualcuno, /impostazioni con una linguetta scelta a memoria no.
 *
 * L'accesso vero vive già su /accesso e funziona: qui la linguetta "Sessione"
 * ne mostra la faccia da dentro — chi è entrato, fino a quando, come si esce.
 * Sta per ULTIMA perché contiene l'uscita, e le azioni che interrompono stanno
 * in fondo, non in cima dove si toccano per sbaglio.
 */

import { useNavigate, useParams } from 'react-router-dom';
import { IntestazionePagina } from '../componenti/Guscio';
import { StrisciaSchede, type VoceScheda } from '../componenti/StrisciaSchede';
import { AccountExchange } from './minori/AccountExchange';
import { DatiStorici } from './minori/DatiStorici';
import { Preferenze } from './minori/Preferenze';
import { Sessione } from './minori/Sessione';

const SEZIONI: (VoceScheda & { titolo: string; sotto: string })[] = [
  {
    chiave: 'account',
    etichetta: 'Account & exchange',
    titolo: 'Account & exchange',
    sotto: 'i conti su cui i bot operano · le chiavi non escono mai dal backend',
  },
  {
    chiave: 'storico',
    etichetta: 'Dati storici',
    titolo: 'Dati storici',
    sotto: 'i backtest possono coprire solo i periodi presenti qui',
  },
  {
    chiave: 'preferenze',
    etichetta: 'Impostazioni',
    titolo: 'Impostazioni',
    sotto: 'sola lettura: il backend non espone preferenze utente',
  },
  {
    chiave: 'sessione',
    etichetta: 'Sessione',
    titolo: 'Sessione',
    sotto: 'chi è entrato, fino a quando, come si esce',
  },
];

const PREDEFINITA = 'account';

export function Impostazioni() {
  const { sezione } = useParams<{ sezione: string }>();
  const naviga = useNavigate();

  /* Una sezione sconosciuta nell'URL non porta a una pagina vuota: ricade su
     quella predefinita, che è anche quella che serve più spesso. */
  const attiva = SEZIONI.find((s) => s.chiave === sezione) ?? SEZIONI[0];

  return (
    <div className="sb-cornice">
      <IntestazionePagina
        titolo={attiva.titolo}
        sotto={<span className="sb-nota">{attiva.sotto}</span>}
      />

      <div style={{ padding: 'var(--sb-pad-pagina)' }} className="sb-colonna">
        <StrisciaSchede
          voci={SEZIONI}
          attiva={attiva.chiave}
          onScegli={(chiave) =>
            naviga(chiave === PREDEFINITA ? '/impostazioni' : `/impostazioni/${chiave}`)
          }
          etichetta="Sezioni delle impostazioni"
        />

        {attiva.chiave === 'account' && <AccountExchange />}
        {attiva.chiave === 'storico' && <DatiStorici />}
        {attiva.chiave === 'preferenze' && <Preferenze />}
        {attiva.chiave === 'sessione' && <Sessione />}
      </div>
    </div>
  );
}
